/* eslint-disable no-underscore-dangle */
import React, { Component, Fragment } from 'react';
import { Nav, AccountSelector } from '@contently/toolkit';
import { get } from '../../../utils/shared/api';
import IaPermissionMapper from './ia_permission_mapper';
import loadingIaMap from './ia_map_loading';
import IaMapManager from './ia_map_manager';
import LinkPermissionManager from './link_permission_manager';
import AccountSwitcherLoader from './account_switcher_loader';
import NullAccountSwitcherLoader from './null_account_switcher_loader';
import CookieJar from '../../utils/cookie_jar';

class ContentlyNav extends Component {
  static onSearch(query) {
    const searchUrl = `${window.location.origin}/search?query=${window.encodeURIComponent(query)}`;
    window.location.href = searchUrl;
  }

  constructor(props) {
    super(props);
    this.iaMapManager = new IaMapManager();
    this._prevAccountId = null;
    this.state = {
      linkData: loadingIaMap,
      ready: false,
      accountData: [],
      activeAccount: { name: 'Loading', children: [], id: 0 },
      activePublication: { name: 'Loading', id: 0 }
    };
  }

  componentDidMount() {
    get('/api/v1/user').then(userData => {
      const accountSwitcherLoader = userData.portfolioOnly
        ? new NullAccountSwitcherLoader()
        : new AccountSwitcherLoader(userData);
      const accountData = accountSwitcherLoader.serialize();

      this.setState(
        {
          accountData,
          activeAccount: accountSwitcherLoader.activeAccount.serialize(),
          activePublication: accountSwitcherLoader.activePublication.serialize(),
          allPublications: accountSwitcherLoader.publications, // For v1 nav without "active account"
          username: userData.username,
          avatar: userData.avatar,
          cashoutBalance: userData.formattedBalance,
          portfolioOnly: userData.portfolioOnly
        },
        this.setIa
      );
    });
  }

  onIaVersionChange = version => {
    this.iaMapManager.currentIA = version;
    // this.setIa();
    // Temp refresh to add/remove rails switcher :(
    this.reload();
  };

  onActiveAccountChange = activeAccount => {
    CookieJar.set('activeAccountId', activeAccount.id);
    if (AccountSwitcherLoader.handleAccountScopedPage(activeAccount.id)) return;
    if (AccountSwitcherLoader.handlePublicationScopedPage(activeAccount.children[0].id)) return;

    this.setState(
      {
        activeAccount,
        activePublication: activeAccount.children[0],
        ready: false
      },
      this.setIa
    );
  };

  onActivePublicationChange = activePublication => {
    CookieJar.set('activePublicationId', activePublication.id);
    if (AccountSwitcherLoader.handlePublicationScopedPage(activePublication.id)) return;

    this.setState({ activePublication, ready: false }, this.setIa);
  };

  setIa() {
    const {
      activeAccount,
      activePublication,
      allPublications,
      username,
      permissionsData,
      cashoutBalance
    } = this.state;

    // For nav v1 with no "active account", we need to check permissions on ALL pubs
    const pubs = this.iaMapManager.currentIA === 'V2' ? activeAccount.children : allPublications;

    const linkPermissionManager = new LinkPermissionManager(
      username,
      activeAccount.id,
      activePublication.id,
      pubs.map(bp => bp.id)
    );

    const ia = this.iaMapManager.load(
      linkPermissionManager,
      this.onIaVersionChange,
      cashoutBalance
    );
    const accountPermissionsPromise = this.accountPermissionsPromise(
      this._prevAccountId,
      activeAccount.id,
      permissionsData
    );

    accountPermissionsPromise.then(({ data }) => {
      IaPermissionMapper(ia, data).then(permittedLinks => {
        this._prevAccountId = activeAccount.id;
        this.setState({
          permissionsData: data,
          linkData: permittedLinks,
          ready: true
        });
      });
    });
  }

  accountPermissionsPromise = (previousAccountId, activeAccountId, permissionsData) => {
    const { portfolioOnly } = this.state;

    if (portfolioOnly) {
      return Promise.resolve({
        data: {
          'user.portfolio': { enabled: true, ttl: 600 }
        }
      });
    }

    if (previousAccountId !== activeAccountId) {
      return get(`/api/v1/user/permissions`, false);
    }

    return Promise.resolve({ data: permissionsData });
  };

  // TMP for version switching
  // eslint-disable-next-line class-methods-use-this
  reload() {
    window.location.reload();
  }

  showAccountSwitcher() {
    return this.iaMapManager.currentIA === 'V2';
  }

  render() {
    const {
      avatar,
      linkData,
      ready,
      accountData,
      activeAccount,
      activePublication,
      portfolioOnly
    } = this.state;

    const accountSwitcher = this.showAccountSwitcher() ? (
      <AccountSelector
        ready={ready}
        accountLabel="Organization"
        accountOptions={accountData}
        onAccountChange={this.onActiveAccountChange}
        selectedAccount={activeAccount}
        subAccountLabel="Publication"
        onSubAccountChange={this.onActivePublicationChange}
        selectedSubAccount={activePublication}
      />
    ) : null;

    return (
      <Fragment>
        {accountSwitcher}
        <Nav
          data={linkData}
          ready={ready}
          onSearch={portfolioOnly ? 'undefined' : ContentlyNav.onSearch}
          searchPlaceholder="Find your stories"
          avatarUrl={avatar}
          theme={this.iaMapManager.currentTheme}
        />
      </Fragment>
    );
  }
}

export default ContentlyNav;



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/nav.jsx